import React, { useState } from 'react';
import { FaShoppingBasket , FaRegWindowClose} from 'react-icons/fa';

import CartItems from './cartItems';

export default function Header(props) {
  let num = props.orders.length;
  let [cartOpen, setCartOpen] = useState(false);
  let sum = Math.floor(props.orders.reduce((prew, elem) => {return prew + (elem.price)},0));
  return (
    <header>
        <div className='hed'>
          <span className='logo'>House Staff</span>
          <nav>
            <ul className='nav'>
              <li className={`nav__item basket ${cartOpen && 'active'}`} num={num} onClick={() => num && setCartOpen(cartOpen = !cartOpen)}>
                <FaShoppingBasket />
              </li>
              <li className='nav__item'>
                  О нас
              </li>
              <li className='nav__item'>
                  Контакты
              </li>
              <li className='nav__item'>
                  Кабинет
              </li>
            </ul>
          </nav>
          {cartOpen && (
                    <div className='shop-cart cart'>
                      <div className='cart__wrap'>
                        <FaRegWindowClose className='shop-cart__close' onClick={()=>setCartOpen(cartOpen = !cartOpen)} />
                        <div className='cart__items'>
                          <div className='sum'>Общая сумма: <span>{sum}</span></div>
                            {props.orders.map((element)=>(
                                <CartItems key={element.id} elem={element} onDelete={props.onDelete}/>
                              ))}
                        </div>
                      </div>
                    </div>
          )}
        </div>
        <div className='presentetion'></div>
    </header>
  )
}
